/**
 * cauHinhSoDem — SỐ ĐẾM trên widget LỐI TẮT (shortcut) của dashboard.
 *
 * Lối tắt vốn chỉ là một nút đi tới màn hình khác. Có những màn hình mà việc đầu tiên người dùng muốn biết
 * là "có bao nhiêu thứ đang chờ mình" — hộp thư tập trung là ví dụ rõ nhất: nhìn dashboard phải thấy ngay
 * còn bao nhiêu tin nhắn chưa đọc, không phải bấm vào mới biết. Khai trong `widgetConfig.badge`:
 *
 *   "badge": {
 *     "apiCode": "channel_message",                        // API (listinfo) để ĐẾM — như widget counter
 *     "condition": { "direction": "in", "read": false },   // điều kiện đếm
 *     "socketEvent": "channel_message",                    // (tuỳ chọn) sự kiện socket -> đếm lại ngay
 *     "label": "tin nhắn chưa đọc"                         // (tuỳ chọn) chữ khi rê chuột lên số
 *   }
 *
 * Số 0 thì KHÔNG hiện gì (một chấm đỏ ghi "0" là nhiễu). Trên 99 hiện "99+".
 * File KHÔNG import gì để test node chạy thẳng trên mã nguồn (xem dashboard-so-dem-test.js).
 */

/** Chuẩn hoá cấu hình số đếm; không khai / khai thiếu API thì trả null (lối tắt vẽ như cũ). */
export const cauHinhSoDem = (widgetConfig) => {
	const b = widgetConfig && widgetConfig.badge;
	if (!b || typeof b !== 'object' || Array.isArray(b)) return null;
	const apiCode = String(b.apiCode || '').trim();
	if (!apiCode) return null;
	const condition = b.condition && typeof b.condition === 'object' && !Array.isArray(b.condition) ? b.condition : {};
	return {
		apiCode,
		condition,
		socketEvent: String(b.socketEvent || '').trim(),
		label: String(b.label || '').trim() || 'mục đang chờ',
	};
};

/** Chữ hiện trên số đếm; 0 / không phải số -> '' (không hiện). */
export const nhanSoDem = (n) => {
	const v = Number(n);
	if (!Number.isFinite(v) || v <= 0) return '';
	return v > 99 ? '99+' : String(Math.floor(v));
};
